import { normalizeMarqueeBrands } from "../lib/homeContent";

export default function HomeMarqueeSection({ brands }) {
    const list = normalizeMarqueeBrands(brands);
    if (list.length === 0) return null;

    const row = list.map((b) => (
        <span key={b}>★ {b}</span>
    ));

    return (
        <section className="bg-[var(--lz-orange)] text-[var(--lz-navy)] py-3 overflow-hidden border-y-2 border-[var(--lz-navy)]">
            <div className="marquee font-display font-bold uppercase tracking-widest text-sm">
                {["a", "b"].map((k) => (
                    <div key={`marquee-${k}`} className="flex gap-12 px-6">
                        {row}
                        {row}
                    </div>
                ))}
            </div>
        </section>
    );
}
